import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
}), 'ReplyAllOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ReplyAllOutlined.js
// module id = 5775
// module chunks = 2